import {Cost} from './types';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import HttpClient from '../../api/api';

export interface CostsState {
    items: Cost[];
}

const initialState: CostsState = {
    items: []
}

const upsertCost = (state: CostsState, cost: Cost) => {
    const index = state.items.findIndex((item) => item.id === cost.id);

    if (index !== -1) {
        state.items[index] = cost;
        return;
    }

    state.items.push(cost);
}

export const getCost = createAsyncThunk(
    'costs/get',
    async (id: number) => {
        const response = await HttpClient.costsApi.get<Cost>(id);
        return response.data;
    }
)

export const getCosts = createAsyncThunk(
    'costs/get-many',
    async (args: { dateFrom: string, dateTo: string, employees: Array<number> }) => {
        const response = await HttpClient.costsApi.getMany<Cost[]>(args.dateFrom, args.dateTo, args.employees);
        return response.data;
    }
)

export const createCost = createAsyncThunk(
    'costs/create',
    async (cost: FormData) => {
        const response = await HttpClient.costsApi.create(cost);
        return response.data;
    }
)

export const deleteCost = createAsyncThunk(
    'costs/delete',
    async (id: number) => {
        const response = await HttpClient.costsApi.delete<Cost>(id);
        return response.data
    }
)

export const updateCost = createAsyncThunk(
    'costs/files',
    async (args: {costId: number, cost: FormData}) => {
        const response = await HttpClient.costsApi.update(args.costId, args.cost);
        return response.data
    }
)

const costsSlice = createSlice({
    name: 'costs',
    initialState,
    reducers: {
        clearCosts: (state) => {
            state.items = initialState.items;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getCosts.fulfilled, (state, action) => {
            state.items = action.payload;
        });
        builder.addCase(getCost.fulfilled, (state, action) => {
            upsertCost(state, action.payload);
        });
        builder.addCase(createCost.fulfilled, (state, action) => {
            upsertCost(state, action.payload);
        });
        builder.addCase(deleteCost.fulfilled, (state, action) => {
            state.items = state.items.filter(item => item.id !== action.meta.arg);
        });
        builder.addCase(updateCost.fulfilled, (state, action) => {
            upsertCost(state, action.payload);
        });
    }
})

export const { clearCosts } = costsSlice.actions;

export default costsSlice.reducer;
